import { NotesListItem } from "@/components/NotesList/NotesListItem";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

export function PlaygroundReviewNotes() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Note list item (avatar size)
        </PlaygroundSubSectionTitle>
        <div className="w-[420px]">
          <NotesListItem
            id="1"
            content="This is a test note"
            createdAt="2026-06-25T17:00:00.000Z"
            firstName="Nora"
            lastName="Gayarre"
            userId={999}
            isLoadingMutation={false}
          />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
